export default __webpack_public_path__ + "static/media/1157.0a863064.png";